// extracted by mini-css-extract-plugin
export default {"content":"Layout_content__rzAoH","menuRoute":"Layout_menuRoute__HA9Ii"};